import React from "react";
import { User } from "../../interfaces/User";
import "./CompanyCard.scss";

// Get image src from ImageData
const getImageSrc = (img?: { data: string; contentType: string } | null): string | null => {
  if (!img) return null;
  return img.data.startsWith("data:") ? img.data : `data:${img.contentType};base64,${img.data}`;
};

export interface CompanyCardProps {
  company: User;
  onClick?: (company: User) => void;
}

export function CompanyCard({ company, onClick }: CompanyCardProps) {
  const logo = company.companyLogos && company.companyLogos.length > 0 
    ? company.companyLogos[0]
    : null;

  const logoSrc = logo ? getImageSrc(logo) : null;
  const companyName = company.companyName || `${company.firstName} ${company.lastName}`.trim() || "Unknown Company";
  const description = company.services || "";
  const website = company.website || "";

  return (
    <div
      className="row align-items-center py-3 px-3 border-bottom company-row"
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick(company);
        }
      }}
    >
      {/* Left: Logo */}
      <div className="col-auto company-row__logo">
        {logoSrc ? (
          <img src={logoSrc} alt={companyName} className="company-logo" />
        ) : (
          <div className="company-logo-placeholder">
            <span>{companyName.charAt(0).toUpperCase()}</span>
          </div>
        )}
      </div>

      {/* Center: Company Info */}
      <div className="col company-row__info">
        <div className="p-semibold mb-1">{companyName}</div>
        {description && (
          <div className="p-small text-muted clamp-2 mb-1">{description}</div>
        )}
        {website && (
          <div className="p-small">
            <a
              href={website.startsWith("http") ? website : `https://${website}`}
              target="_blank"
              rel="noopener noreferrer"
              className="company-website-link"
              onClick={(e) => e.stopPropagation()}
            >
              {website.replace(/^https?:\/\//, "")}
            </a>
          </div>
        )}
      </div>

      {/* Right: Actions (placeholder for future features like star/favorite) */}
      <div className="col-auto company-row__actions">
        {/* Future: Add star/favorite icon, ellipsis menu, etc. */}
      </div>
    </div>
  );
}

